module.exports = __webpack_public_path__ + "assets/images/home-hero-background-unbranded-af23743b76d26ec9d5c160558a2e18ef.png";